import { formConstants } from '../../../../utils/constants/form-constants';

const UserReferralFormData = (
    {
        ssoUserReferralFields,
        getUserReferralCallbackUrl
    },
    campaignData
) => {
    function buildUserReferralFormData() {
        const formData = getUserReferralFields();
        return getUserReferralFieldsWithDefaultValues(formData);
    }

    function getUserReferralFields() {
        const formData = {};
        const { formTitle, formSubTitle } = ssoUserReferralFields;
        formData[formConstants.getUserReferralCallbackUrl] = getUserReferralCallbackUrl;
        formData[formConstants.formTitle] = formTitle;
        formData[formConstants.formSubTitle] = formSubTitle;
        formData[formConstants.personalReferralCode] = ssoUserReferralFields[formConstants.personalReferralCode];
        return formData;
    }

    function getUserReferralFieldsWithDefaultValues(formData) {
        formData[formConstants.personalReferralCode].defaultValue = campaignData[formConstants.personalReferralCode] || '';

        return formData;
    }

    return buildUserReferralFormData();
};

export default UserReferralFormData;
